import axios from "axios";
// import axios from '@/utils/axios'
import { MessageBox, Message } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: "https://yun-api.bigdata5s.com", // 绿色云农
  // baseURL:'http://192.168.0.133:8769/v1/',
  withCredentials: true, // send cookies when cross-domain requests  跨域请求时发送cookie
  timeout: 50000, // request timeout  请求超时
  // token:localStorage.getItem('screenToken')
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = localStorage.getItem("screenToken");
    config.headers["issuer"] = "enroll";
    config.headers["cvn-user-id"] = localStorage.getItem("userId");

    // // get请求映射params参数
    // if (config.method === 'get' && config.params) {
    //   let url = config.url + '?';
    //   for (const propName of Object.keys(config.params)) {
    //     const value = config.params[propName];
    //     var part = encodeURIComponent(propName) + "=";
    //     if (value !== null && typeof(value) !== "undefined") {
    //       if (typeof value === 'object') {
    //         for (const key of Object.keys(value)) {
    //           let params = propName + '[' + key + ']';
    //           var subPart = encodeURIComponent(params) + "=";
    //           url += subPart + encodeURIComponent(value[key]) + "&";
    //         }
    //       } else {
    //         url += part + encodeURIComponent(value) + "&";
    //       }
    //     }
    //   }
    //   url = url.slice(0, -1);
    //   config.params = {};
    //   config.url = url;
    // }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// response interceptor  响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status) {
      res.code = res.status;
    }

    // if the custom code is not 20000, it is judged as an error.  如果自定义代码不是20000，就会被判定为错误。
    if (res.code != 200 && res.code != 500) {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      if (res.code == 500) {
        // Message({
        //   message: res.msg || 'Error',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
      }
      return res;
    }
  },
  (error) => {
    // console.log(error)
    // console.log('err' + error) // for debug
    if (!error.response) {
      Message({
        message: "网络连接异常，请检查网络",
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);
export default service;
